import { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { useMandatorContext } from "@rentablo/theming";
import DayIcon from "@icons/myicons/day.svg?react";
import NightIcon from "@icons/myicons/night.svg?react";
import { useMyself } from "@api";
import { ROLE_MANDATOR_VIEWER, ROLE_QUALITY_ASSURANCE } from "@constants";

// QA checks every mandator theme, so it gets the switcher as well.
const SWITCHER_ROLES = [ROLE_MANDATOR_VIEWER, ROLE_QUALITY_ASSURANCE];

export const MandatorsSlugSelect = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { data: myself } = useMyself();
  const {
    mandatorSlug,
    mandatorsList,
    setLocalMandatorSlug,
    mode,
    setLocalMode,
  } = useMandatorContext();

  if (
    !["staging", "development", "sandbox", "e2e"].includes(
      import.meta.env.VITE_APP_ENVIRONMENT ?? ""
    ) ||
    !SWITCHER_ROLES.some((role) => myself?.roles?.includes(role))
  )
    return null;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <IconButton
        size="small"
        onClick={() => {
          setLocalMode(mode === "light" ? "dark" : "light");
        }}
      >
        {mode === "light" ? <DayIcon /> : <NightIcon />}
      </IconButton>
      <Box
        ref={setAnchorEl}
        onClick={() => setIsOpen(true)}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          cursor: "pointer",
          background: (theme) => theme.palette.background.default,
          borderRadius: "50%",
          width: "40px",
          height: "40px",
        }}
      >
        {mandatorSlug?.slice(0, 3)}
      </Box>
      <Menu
        open={isOpen}
        anchorEl={anchorEl}
        keepMounted
        onClose={() => setIsOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {mandatorsList.map((mandator) => (
          <MenuItem
            key={mandator}
            value={mandator}
            onClick={() => {
              setLocalMandatorSlug(mandator);
              setIsOpen(false);
            }}
            selected={mandator === mandatorSlug}
          >
            {mandator}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
